export const NAVERWORKS_DRIVE_TYPE = {
  PERSONAL: 'personal',
  SHARE: 'share',
  GROUP: 'group'
};

export const NAVERWORKS_ROOT_FOLDER_NAME = 'root';
export const NAVERWORKS_FOLDER_TYPE_NAME = 'folder';

export const NAVERWORKS_NAVIGATOR_TYPE = {
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE'
};

export const NAVERWORKS_SUPPORT_IMAGE_EXT = {
  jpg: { mimeType: 'image/jpeg' },
  jpeg: { mimeType: 'image/jpeg' },
  bmp: { mimeType: 'image/bmp' },
  gif: { mimeType: 'image/gif' },
  png: { mimeType: 'image/x-png' },
  emf: { mimeType: 'image/emf' },
  wmf: { mimeType: 'image/wmf' },
  tif: { mimeType: 'image/tif' },
  tiff: { mimeType: 'image/tiff' }
};

export const SUPPORT_IMAGE_THUMBNAIL_SIZE = 5; //MB
